import React from 'react';
import { View, Text } from 'react-native';
import { styles } from './styles';

interface TableSubHeaderProps {
  dayLabels: string[];
  responsiveStyles: {
    headerHeight: number;
    addZoneMinWidth: number;
    addZoneMaxWidth: number;
    dayGroupMinWidth: number;
    kcphMinWidth: number;
    fontSize: {
      subHeader: number;
    };
  };
  hasOverrideValuesForDay: (dayKey: 'sun' | 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat') => boolean;
  hasOverrideValuesForKCPH: () => boolean;
}

const TableSubHeader: React.FC<TableSubHeaderProps> = ({
  dayLabels,
  responsiveStyles,
  hasOverrideValuesForDay,
  hasOverrideValuesForKCPH,
}) => {
  return (
    <View style={[
      styles.subHeader,
      { minHeight: responsiveStyles.headerHeight * 1.5 }
    ]}>
      {/* Zones Column */}
      <View style={[
        styles.zonesSection,
        { minWidth: responsiveStyles.addZoneMinWidth, maxWidth: responsiveStyles.addZoneMaxWidth }
      ]}>
        <View style={[
          styles.zonesHeader,
          { height: responsiveStyles.headerHeight * 0.8 }
        ]}>
          <Text style={[
            styles.dayHeaderText,
            { fontSize: responsiveStyles.fontSize.subHeader, fontWeight: 'bold' }
          ]}>
            
          </Text>
        </View>
        <View style={styles.zonesSubColumn}>
          <View style={styles.subColumn}>
            <Text style={[
              styles.subHeaderText,
              { fontSize: responsiveStyles.fontSize.subHeader - 1, fontWeight: 'bold' }
            ]}>
              Zones
            </Text>
          </View>
          <View style={styles.inputColumnDivider} />
        
        </View>
      </View>

      <View style={styles.inputColumnDivider} />

      {/* Days with Default/Override columns */}
      <View style={styles.daysGroup}>
        {dayLabels.map((day, index) => {
          const dayKey = day.toLowerCase() as 'sun' | 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat';
          const hasOverride = hasOverrideValuesForDay(dayKey);
          
          return (
            <React.Fragment key={`day-${day}`}>
              {index > 0 && <View style={styles.inputColumnDivider} />}
              <View style={[
                styles.dayGroup,
                { minWidth: responsiveStyles.dayGroupMinWidth }
              ]}>
                <View style={[
                  styles.dayHeader,
                  { height: responsiveStyles.headerHeight * 0.8 }
                ]}>
                  <Text style={[
                    styles.dayHeaderText,
                    { fontSize: responsiveStyles.fontSize.subHeader }
                  ]}>
                    {day}
                  </Text>
                </View>
                <View style={styles.daySubColumns}>
                  <View style={styles.subColumn}>
                    <Text style={[
                      styles.subHeaderText,
                      { 
                        fontSize: responsiveStyles.fontSize.subHeader - 1,
                        fontWeight: 'normal',
                        color: !hasOverride ? 'black' : '#666666'
                      }
                    ]}>
                      Default
                    </Text>
                  </View>
                  <View style={styles.inputColumnDivider} />
                  <View style={styles.subColumn}>
                    <Text style={[
                      styles.subHeaderText,
                      { 
                        fontSize: responsiveStyles.fontSize.subHeader - 1,
                        fontWeight: hasOverride ? 'bold' : 'normal',
                        color: hasOverride ? 'black' : '#666666'
                      }
                    ]}>
                      Override
                    </Text>
                  </View>
                </View>
              </View>
            </React.Fragment>
          );
        })}
      </View>

      <View style={styles.inputColumnDivider} />

      {/* Restore Column */}
      <View style={[
        styles.dayGroup,
        { minWidth: responsiveStyles.dayGroupMinWidth - 1 },
        { maxWidth: responsiveStyles.dayGroupMinWidth - 1 }
      ]}>
        <View style={[
          styles.dayHeader,
          { height: responsiveStyles.headerHeight * 0.8 }
        ]}>
          <Text style={[
            styles.dayHeaderText,
            { fontSize: responsiveStyles.fontSize.subHeader }
          ]}>
          </Text>
        </View>
        {/* Single full-width sub-header for restore column to match content structure */}
        <View style={[styles.restoreSubHeader]}>
          <Text style={[
            styles.subHeaderText,
            { fontSize: responsiveStyles.fontSize.subHeader - 1 }
          ]}>
          </Text>
        </View>
      </View>

      <View style={styles.inputColumnDivider} />

      {/* KCPH Column */}
      <View style={[
        styles.kcphGroup,
        { minWidth: responsiveStyles.kcphMinWidth }
      ]}>
        <View style={[
          styles.kcphHeader,
          { height: responsiveStyles.headerHeight * 0.8 }
        ]}>
          <Text style={[
            styles.dayHeaderText,
            { fontSize: responsiveStyles.fontSize.subHeader }
          ]}>
            AVG Hist KCPH (QTR)
          </Text>
        </View>
        <View style={styles.kcphSubColumns}>
          <View style={styles.subColumn}>
            <Text style={[
              styles.subHeaderText,
              { 
                fontSize: responsiveStyles.fontSize.subHeader - 1,
                fontWeight: 'normal'
              }
            ]}>
              Default
            </Text>
          </View>
          <View style={styles.inputColumnDivider} />
          <View style={styles.subColumn}>
            <Text style={[
              styles.subHeaderText,
              { 
                fontSize: responsiveStyles.fontSize.subHeader - 1,
                fontWeight: hasOverrideValuesForKCPH() ? 'bold' : 'normal'
              }
            ]}>
              Override
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default TableSubHeader;